var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.121,
    height: 14.121,
    viewBox: "0 0 14.121 14.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3",
    "data-name": "Raggruppa 3",
    transform: "translate(-469.939 -515.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Below",
    d: "M0,0,6-5.992,0-12",
    transform: "translate(483 529) rotate(-90)",
    fill: "none",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Below-2",
    "data-name": "Below",
    d: "M0,0,6,5.992,0,12",
    transform: "translate(483 517) rotate(90)",
    fill: "none",
    stroke: "#646464",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.893056faf6cecf9fbee3fa14ce798ea2.svg";
export { ForwardRef as ReactComponent };